<template>
    <div id="departments">
     
    <ul id="card-list">
    <li
      class="card"
      :class="(department.name || '').toLowerCase().replace(/\s+/g, '-')"
      v-for="department in departments"
      :key="department.id"
      @click="StartGame(department)"
    >
        <div class="card-image-wrapper">
            <img 
                v-if="department.front_image" 
                :src="department.front_image" 
                :alt="`${department.name} department card`"
                @load="onImageLoad"
                @error="onImageError"
            />
            <span v-if="isDemoOnly(department.id)" class="demo-badge">Demo</span>
        </div>
    
            <div v-if="imageLoading" class="image-loading">
                <div class="loading-spinner"></div>
            </div>
        <div v-if="department.primary_color" :style="{color: department.primary_color}" class="card-title">
            <h2>{{ department.name }}</h2>
        </div>
        <p v-if="department.description" class="card-description">{{ department.description }}</p>
    </li>

    </ul>
   
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { supabase } from "@/supabase";
import { useGameStore } from '@/stores/gameStore';
import { useRouter } from 'vue-router';
const router = useRouter();
const gameStore = useGameStore();
const departments = ref([]);
const imageLoading = ref(false);

// Map of department_id → access_mode for email-authed users
const userAccess = ref({});

const fetchDepartments = async () => {
  const { data, error } = await supabase
    .from('departments')
    .select('*')
    .order('position', { ascending: true });
  if (error) {
    console.error('Error fetching departments:', error);
    return;
  }

  // For email-authed users, filter to assigned departments and build access map.
  const accessRaw = localStorage.getItem('userDeptAccess');
  if (accessRaw) {
    try {
      const access = JSON.parse(accessRaw);
      const accessMap = {};
      access.forEach(r => { accessMap[r.department_id] = r.access_mode; });
      userAccess.value = accessMap;
      departments.value = (data || []).filter(d => accessMap[d.id] !== undefined);
      return;
    } catch { /* fall through */ }
  }

  departments.value = data || [];
};

// Returns true if this user only has demo access to the given department
const isDemoOnly = (deptId) => userAccess.value[deptId] === 'demo_only';

const StartGame = (department) => {
  const demo = isDemoOnly(department.id);

  // Update game session in localStorage so fetchCardsByDepartment
  // reads the correct isDemo flag before loading cards.
  try {
    const raw = localStorage.getItem('gameSession');
    const session = raw ? JSON.parse(raw) : {};
    session.isDemo = demo;
    session.demoDepartmentId = demo ? department.id : null;
    localStorage.setItem('gameSession', JSON.stringify(session));
  } catch { /* ignore */ }

  // Apply to the store immediately so isDemoSession is correct before
  // fetchCardsByDepartment runs in HomeView's onMounted.
  gameStore.applyGameSessionFromStorage();

  // Set the department BEFORE resetGame so fetchCardsForReset uses the correct
  // department ID and demo flag when it runs internally.
  gameStore.setSelectedDepartment(department.id);
  gameStore.resetGame();
  router.push({ name: 'Game', params: { departmentId: department.id } });
};

const onImageLoad = () => {
  imageLoading.value = false;
};

const onImageError = (event) => {
  imageLoading.value = false;
  console.warn('Failed to load department image:', event.target.src);
  // Hide the broken image
  event.target.style.display = 'none';
};
onMounted(() => {
  fetchDepartments();
});

</script>

<style src="../styles/_departments.scss" lang="scss"></style>